<template>
  <div>
    <h2 class="page-title-bar">
      <img class="imgageproperty" src="@/assets/img/errorlist.png" alt="save" />
      {{ $t("ESL Low battery") }}
    </h2>

   <div class="searchArea">
    <div class="col-8">
      <label
        ><strong>{{ $t("Dept.") }}</strong></label
      >
      <v-select
        style="width: 100%l;display: inline-grid"
        v-model="searchBy.department"
        :placeholder="$t('Dept.')"
        :items="departmentList"
        class="form-select ml-3"
        item-text="name"
        item-value="level"
        outlined
        dense
        hide-details
        clearable
      >
      </v-select>
      </div>
       <div class="col-4" style="display: flex; justify-content:end;">
      <label class="lastupdated">{{ $t("Last Updated Time") }} &nbsp;</label>
      <label
        ><span class="lastupdateddate ml-1">: <b>{{ lastUpdatedTime }}</b></span></label
      >
      </div>
    </div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :hide-default-footer="true"
      :options.sync="options"
      :server-items-length="totalVisiblePages"
      class="tbl-type01 mt-10"
    >
      <template slot="no-data">
        <p>{{ $t("No data available") }}</p>
      </template>
    </v-data-table>

    <div class="table-options">
      <div>
        <v-btn
          :disabled="btnDisabledExport || btnDisabledExportCheckList || exportDisabled"
          @click="exportUserInfoList"
          class="btn ml-2"
          text
        >
          {{ $t("Export") }}
        </v-btn>
      </div>
      <div>
        <div class="pageInfo">{{ pageInfoText }}</div>
        <v-pagination
          v-model="page"
          @input="paging"
          :length="totalPages"
          :total-visible="totalVisiblePages"
          color="#2f3b4c"
        ></v-pagination>
      </div>
    </div>
    <a ref="link" :style="{ display: 'none' }" />
  </div>
</template>

<script>
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import { mapGetters } from 'vuex'
// import { exportFiles } from '@/plugins/exporter'
import commons from '@/plugins/commons'

const requests = {
  getLowBatteryInfo: {
    method: 'get',
    url: '/metro/report/low-battery'
  },
  getPdfLowBatteryInfo: {
    method: 'post',
    url: '/metro/report/low-battery-pdf'
  }
}

export default {
  name: 'ESLProductInfo',

  data () {
    return {
      productionType: process.env.VUE_APP_PRODUCTION_TYPE,
      btnDisabledExport: null,
      pageCount: 0,
      tableItems: [],
      selected: [],
      options: {},
      ROW_CLASS: 'row-class',
      page: 1,
      totalPages: 0,
      pageInfoText: null,
      totalVisiblePages: 7,
      exportDisabled: false,
      userEditItem: {},
      requestConfig: {},
      searchBy: { department: null },
      searchParam: {
        company: null,
        store: null,
        page: null,
        size: '10',
        sort: 'code,asc'
      },
      startIndex: null,
      totalData: [],
      endindex: null,
      lastUpdatedTime: null,
      departmentList: []
    }
  },
  computed: {
    tableHeaders () {
      return [
        {
          text: this.$t('DEPT'),
          sortable: false,
          align: 'center',
          value: 'dept',
          width: '95px'
        },
        {
          text: this.$t('ITEM GROUP'),
          sortable: false,
          align: 'center',
          value: 'itemGroup',
          width: '85px'
        },
        {
          text: this.$t('ITEM ID'),
          sortable: false,
          value: 'itemId',
          align: 'center',
          width: '85px'
        },
        {
          text: this.$t('DESCRIPTION'),
          sortable: false,
          align: 'center',
          value: 'description',
          width: '95px'
        },
        {
          text: this.$t('LABEL ID'),
          sortable: false,
          value: 'labelId',
          width: '90px',
          align: 'center'
        },
        {
          text: this.$t('UPDATED DATE'),
          sortable: false,
          value: 'updatedDate',
          width: '90px',
          align: 'center'
        }
      ]
    },
    btnDisabledExportCheckList () {
      var flag = true
      if (this.tableItems !== undefined && this.tableItems.length) flag = false
      return flag
    },
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    }
  },
  watch: {
    store: {
      handler () {
        this.page = 1
        this.getLowBatteryInfo(this.page)
        this.getDepartmentList()
      }
    },
    searchBy: {
      handler (newSearchBy) {
        console.log(newSearchBy)
        if (newSearchBy) {
          this.page = 1
        }
        this.getLowBatteryInfo(1)
      },
      deep: true
    }
  },
  created () {
    this.user = this.$store.state.auth.user
  },
  mounted () {
    this.getLowBatteryInfo(1)
    this.$store.dispatch('auth/getDisabledBtn', '11300').then((flag) => {
      this.exportDisabled = flag
    })
    EventBus.$emit('enableSelectedStores', true)

    if (!this.store.code) {
      EventBus.$emit('openSelectedStores')
    } else {
      this.getLowBatteryInfo(1)
      this.getDepartmentList()
    }
  },
  methods: {
    paging (page) {
      this.getLowBatteryInfo(page)
    },
    exportUserInfoList () {
      const exportdata = {
        guiMap: {
          dept: this.$t('DEPT'),
          store_name: this.$t('STORE NAME'),
          itemGroup: this.$t('ITEM GR'),
          itemId: this.$t('ITEM ID'),
          description: this.$t('DESCRIPTION'),
          labelId: this.$t('LABEL ID'),
          updatedDate: this.$t('UPDATED DATE'),
          title_batteryinfo: this.$t('LOW BATTERY')
        },
        msgMap: {
          M0124: this.$t('date Edited'),
          M0125: this.$t('Signature Dept. Head'),
          M0126: this.$t('Error Code'),
          M0127: this.$t('ESL No'),
          M0128: this.$t('ESL no reception'),
          M0129: this.$t('ESL with an incorrect price'),
          M0130: this.$t('ESL false indication info level'),
          M0131: this.$t('Destroyed ESL'),
          M0132: this.$t('Other')
        }
      }

      const params = { company: this.user.company, store: this.store.code, lang: this.$store.getters['dataStore/GET_CURRENT_LANGUAGE'] }
      const config = { params: params }
      config.responseType = 'arraybuffer'
      this.$utils
        .callAxiosWithBody(
          requests.getPdfLowBatteryInfo.method,
          requests.getPdfLowBatteryInfo.url,
          exportdata,
          config
        )
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'Lowbattery.pdf'
          link.click()
        })
        .catch(error => {
          console.debug(error)
        })
    },
    insertIndex (tableData, headers) {
      let idx = Number(headers['x-number'] * headers['x-size']) + 1
      tableData = tableData.map((tableItems) => {
        tableItems.no = idx
        idx++
        return tableItems
      })
      return tableData
    },
    sortingBuilingData (sortingParam, tableData) {
      const sortingParamDetails = sortingParam.split(',')
      const keyType = sortingParamDetails[0]
      const orderType = sortingParamDetails[1]
      if (keyType === 'code') {
        return tableData
      }
      return tableData.sort(compareValues(keyType, orderType))
      function compareValues (key, order = 'ASC') {
        return function innerSort (a, b) {
          if (
            !Object.prototype.hasOwnProperty.call(a, key) ||
            !Object.prototype.hasOwnProperty.call(b, key)
          ) {
            // property doesn't exist on either object
            return 0
          }
          const varA =
            typeof a[key] === 'string' ? a[key].toUpperCase() : a[key]
          const varB =
            typeof b[key] === 'string' ? b[key].toUpperCase() : b[key]

          let comparison = 0
          if (varA > varB) {
            comparison = 1
          } else if (varA < varB) {
            comparison = -1
          }
          return order === 'DESC' ? comparison * -1 : comparison
        }
      }
    },
    handlegetLowBatteryInfoResponse (res) {
      if (res.status === 204) {
        this.handlegetLowBatteryInfoError('No content')
        return
      }
      this.tableItems = res.data.batteryInfoList
      this.lastUpdatedTime = res.data.lastUpdatedTime
      this.pageInfoText = this.getPageInfoText(res.headers)
      if (commons.isValidStr(res.headers['x-totalpages'])) {
        this.totalPages = res.headers['x-totalpages'] * 1
      }
    },
    getPageInfoText: function (headers) {
      if (headers['x-totalelements'] === 0) return '0 to 0, 0' + ' ' + this.$t('in total')
      return `${headers['x-number'] * 1 * headers['x-size'] + 1} 
      ${this.$t('to')} ${(headers['x-number'] * 1 * headers['x-size']) + headers['x-total-count'] * 1},
       ${headers['x-totalelements'] * 1}` + ' ' + this.$t('in total')
    },
    handlegetLowBatteryInfoError (error) {
      this.tableItems = []
      const headers = {}
      headers['x-totalelements'] = 0
      this.pageInfoText = this.getPageInfoText(headers)
      this.totalPages = 0
      console.debug(error)
    },
    buildParmas: function () {
      const { sortBy, sortDesc, itemsPerPage } = this.options
      const params = { company: this.user.company, store: this.store.code }
      let sort = null
      if (sortBy && sortBy.length === 1 && sortDesc && sortDesc.length === 1) {
        const sortKey = sortBy[0]
        const sortOrder = sortDesc[0]
        sort = `${sortKey},${sortOrder ? 'desc' : 'asc'}`
      }
      if (sort !== null) params.sort = sort
      if (itemsPerPage > 0) params.size = itemsPerPage
      return params
    },
    getLowBatteryInfo (page) {
      const params = this.buildParmas()
      params.dept = this.searchBy.department
      if (page !== null) params.page = page - 1
      const config = { params: params }
      if (commons.isNull(config.params.store) || config.params.store === '') {
        this.handlegetLowBatteryInfoError('')
        return
      }
      this.$utils
        .callAxios(
          requests.getLowBatteryInfo.method,
          requests.getLowBatteryInfo.url,
          config
        )
        .then((res) => {
          this.handlegetLowBatteryInfoResponse(res)
        })
        .catch((error) => {
          this.handlegetLowBatteryInfoError(error)
        })
    },
    getDepartmentList () {
      const params = { company: this.user.company, store: this.store.code }
      const config = { params: params }
      this.$utils
        .callAxios(
          codes.requests.getDepartmentList.method,
          codes.requests.getDepartmentList.url,
          config
        )
        .then((res) => {
          this.departmentList = res.data.deptList
        })
        .catch((error) => {
          this.departmentList = []
          console.debug(error)
        })
    }
  }
}
</script>

<style scoped>
.v-input {
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  font-size: 12px;
  letter-spacing: normal;
  max-width: 18% !important;
  text-align: left;
}
.lastupdated1 {
  position: absolute;
  right: 56px;
  /* margin-top: -18px; */
  font-size: 14px;
}
.lastupdateddate1 {
  position: absolute;
  right: 46px;
  font-size: 14px;
}
/* .v-application .mt-10 {
  margin-top: 0px !important;
} */
.v-application .text-center {
  text-align: left !important;
}
.imgageproperty {
  margin-right: 14px;
  height: 24px;
}
</style>
